import { render, staticRenderFns } from "./Inscription-public.vue?vue&type=template&id=639a2e44&scoped=true&"
import script from "./Inscription-public.vue?vue&type=script&lang=js&"
export * from "./Inscription-public.vue?vue&type=script&lang=js&"
import style0 from "./Inscription-public.vue?vue&type=style&index=0&id=639a2e44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639a2e44",
  null
  
)

export default component.exports